/* global Sys, Core */
Sys.ns("Core");

/**
 * The base View class.
 *
 * This class should be used as base when creating a new view.
 *
 * @class Core.View
 * @extends Sys.Observable
 * @aside guide events__events
 */
Core.View = {

    /**
     * @cfg name The name of the module
     */

    /**
     * @cfg model The model
     */

    /**
     * @constructs
     * @param {Object} config The configuration object.
     * @returns {void}
     */
    constructor: function(config) {
        Core.View.superclass.constructor.apply(this, arguments);

        this.init(config);
    },

    /**
     * Initialize the View.
     *
     * @protected
     * @param {Object} config The configuration object.
     * @returns {void}
     */
    init: function(config) {
        this.model = config.model;
        this.MODULE_NAME = config.name;

        this.setupEvents();
    },

    /**
     * Setup the event listeners.
     *
     * @protected
     * @returns {void}
     */
    setupEvents: function() {
        // Intentionally left empty
    }

};

Core.View = Sys.extend(Sys.Observable, Core.View, "Core.View");
